import script from "./Case.vue?vue&type=script&lang=ts&setup=true"
export * from "./Case.vue?vue&type=script&lang=ts&setup=true"

import "./Case.vue?vue&type=style&index=0&id=91ed8b4c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91ed8b4c"]])

export default __exports__